<template>
  <div class="mask" :style="styles" @click="maskClick($event)"></div>
</template>

<script>
    export default {
        name: "BaseMask",
        props: {
            styles: {
                type: Object,
                default: () => {}
            },
            lockScroll: {
                type: Boolean,
                default: false
            },
            /**
             * 遮罩点击事件是否阻止冒泡
             */
            clickStopPropagation: {
                type: Boolean,
                default: false
            }
        },
        created() {
            if (this.lockScroll) {
                document.body.style.overflow = 'hidden';
            }
        },
        mounted(){
            this.$removeToBody();
        },
        destroyed() {
            if (this.lockScroll) {
                document.body.style.overflow = 'auto';
            }
        },
        methods: {
            maskClick(e) {
                this.$emit('click');
                if (this.clickStopPropagation)
                    e.stopPropagation();
            }
        }
    }
</script>


<style scoped>
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: #00000066;
  }
</style>



// WEBPACK FOOTER //
// src/view/baseComponent/BaseMask.vue